import { Layout } from "../Pages/Data/Visualize/DataReview/Types/Layout"
import { VisualizationComponent } from "../Pages/Data/Visualize/DataReview/VisualizationComponent"

const templates = [
	[["a"]],
	[["a", "b"]],
	[["a"], ["b"]],
	[["a", "b", "b"]],
	[["a", "a", "b"]],
	[["a", "b", "c"]],
	[
		["a", "b"],
		["a", "c"],
	],
	[
		["a", "b"],
		["c", "d"],
	],
	[
		["a", "b"],
		["a", "b"],
		["a", "b"],
		["a", "b"],
		["a", "b"],
		["c", "c"],
		["c", "c"],
	],
]

export const layoutOptions: Layout[] = templates.map((template, index) => ({
	id: index.toString(),
	name: "placeholder",
	cssGridTemplate: template,
	areas: [...new Set(template.flat())].map((uniqueArea) => ({
		area: uniqueArea,
		componentId: VisualizationComponent.PLACEHOLDER,
	})),
}))
